// extracted by mini-css-extract-plugin
export default {"EditorPage":"EditorPage_EditorPage__+xyfu","MainLayout":"EditorPage_MainLayout__5FW1v"};